import React from "react";
import "../../../styles/main.css";
import PageHeader from "../../../components/reusable/ModuleHeader/PageHeader";
import Breadcrumb from "../../../components/reusable/ModuleHeader/Breadcrumb";
import Subpage_102_architecture from "../../../modules/caneva/Subpage_102_architecture";

const Page_102_architecture = () => {
  return (
    <div
      style={{
        padding: 0,
        margin: 0,
        boxSizing: "border-box",
        minWidth: 1200,   // largeur logique de page
      }}
    >
      <Breadcrumb
        items={[
          { label: "homepage", href: "/Homepage" },
          { label: "caneva / architecture", href: "/page_102" },
        ]}
      />

      {/* <PageHeader
        title="Architecture"
        className="title-caneva"
      />

      <hr className="page-separator" /> */}

      <main
        className="content"
        style={{
          padding: 0,
          margin: 0,
          background: "transparent",
          boxSizing: "border-box",
        }}
      >
        <Subpage_102_architecture />
      </main>
    </div>
  );
};

export default Page_102_architecture;
